import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Card,
  Button,
  Stack,
  Tooltip,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  useLocation
} from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from '@mui/styles';
import SelectDropdown from "../common/FormSelectDropdown";
import { useLoader } from "../../../pages/LoaderContext";
import { successToast, errorToast } from "../../utils/toast";
import { ToastContainer } from 'react-toastify';
import UnSavedModal from "../common/UnSavedModal"
import { useAppContext } from '../../../hooks/context/AppContext';
import { useProjectApiClient } from "../../Services/api/projectService"
import ValidationModal from "../common/ValidationModal"
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';
import FileUpload from "../common/FileUpload";
import UploadList from "../common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";


import { useEngineeringScopeApiClient } from "../../Services/api/engineeringScopeService"
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../common/TextInput";
import { projectVersion } from "config/navConfig";


const useStyles = makeStyles({
  themeButton: {
    backgroundColor: '#2a3fbf !important',
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#2a3fbf !important' },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
  }
});

interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}

const EngineeringScope: React.FC = () => {
  const location = useLocation();
  const {
    getProjectDetails,
    getRequiredField,
    publishProjectOnSave,
    uploadProjectFile
  } = useProjectApiClient();
  const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
  const {
    getCivilScope,
    getMakingScope,
    getPacking,
    getEolScope,
    getESManufacturingComeple,
    getESLowCostSuppliersinScope,
    getPrimaryPack,
    getClosureMould,
    getTechnicalRisk,
    getEngineeringScope,
    createEngineeringScope,
    updateEngineeringScope
  } = useEngineeringScopeApiClient();
  const { appData, updateAppData, userData } = useAppContext();
  const classes = useStyles();
  const navigate = useNavigate();
  const [civilsScopes, setCivilsScopes] = useState([])
  const [makingScopes, setMakingScopes] = useState([])
  const [packings, setPackings] = useState([])
  const [eolScopes, setEolScopes] = useState([])
  const [newPrimaryPacks, setNewPrimaryPacks] = useState([])
  const [newClosers, setNewClosers] = useState([])
  const [manufacturingDesigns, setManufacturingDesigns] = useState([])
  const [suppliersScope, setSuppliersSope] = useState([])
  const [risks, setRisks] = useState([])
  const { loading, setLoading } = useLoader();
  const [isExisting, setIsExisting] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true);
  const [validationErrors, setValidationErrors] = useState({})
  const [isValidationError, setIsValidationError] = useState(false)
  const [projectDetails, setProjectDetails] = useState({
    issaved: false
  })
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10)
  const hasAutoSaved = useRef(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [formData, setFormData] = useState({
    civilsScope: '',
    makingScope: '',
    packing: '',
    eolScope: '',
    newPrimaryPack: '',
    newCloser: '',
    manufacturingDesign: '',
    suppliersScope: '',
    risk: '',
    Capex: '',
    comment: ''
  })

  const [initialformData, setInitialformData] = useState({
    civilsScope: '',
    makingScope: '',
    packing: '',
    eolScope: '',
    newPrimaryPack: '',
    newCloser: '',
    manufacturingDesign: '',
    suppliersScope: '',
    risk: '',
    Capex: '',
    comment: ''
  })


  const schema = yup.object().shape({
    civilsScope: yup.string(),
    makingScope: yup.string(),
    packing: yup.string(),
    eolScope: yup.string(),
    newPrimaryPack: yup.string(),
    newCloser: yup.string(),
    manufacturingDesign: yup.string(),
    suppliersScope: yup.string(),
    risk: yup.string(),
    Capex: yup
      .number()
      .nullable()
      .transform((value, originalValue) => (originalValue === "" ? null : value))
      .typeError("Capex must be a number"),
    comment: yup.string().notRequired().nullable(),

  });



  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
    // @ts-ignore
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }
  }, [userData]);


  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);


  useEffect(() => {

    const fetchOptions = async () => {
      await Promise.all([
        fetchCivilScope(),
        fetchMakingScope(),
        fetchPacking(),
        fetchEolScope(),
        fetchPrimaryPack(),
        fetchClosureMould(),
        fetchESManufacturingComeple(),
        fetchESLowCostSuppliersinScope(),
        fetchTechnicalRisk(),
        fetchsProjectDetails()
      ]);
    };
    fetchOptions();
    if (projectKey) {
      fetchEngineeringScope(projectKey);
    }
  }, [projectKey]);



  useEffect(() => {
    let check = JSON.stringify(formData) == JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }

  }, [formData]);


  useEffect(() => {
    // @ts-ignore
    reset(formData);
  }, [formData]);

  // useEffect(() => {
  //   if (projectKey) {
  //     fetchEngineeringScope(projectKey);
  //   }
  // }, [projectKey]);



  const fetchsProjectDetails = async () => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved })
        setIsDraftDisabled(data.issaved)
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchEngineeringScope = async (key: string) => {
    try {
      setLoading(true)
      const data = await getEngineeringScope(key);
      setLoading(false)
      if (data) {
        if (data.Escope_Id) {
          setIsExisting(true)
        }
        let projectData = {
          civilsScope: JSON.stringify(data.Civils_Scope_Key),
          makingScope: JSON.stringify(data.Making_Scope_Key),
          packing: JSON.stringify(data.Packing_Key),
          eolScope: JSON.stringify(data.Eol_Scope_Key),
          newPrimaryPack: JSON.stringify(data.New_Primary_Pack_Mould),
          newCloser: JSON.stringify(data.New_Closure_Mould),
          manufacturingDesign: JSON.stringify(data.Design_For_Manufacturing_Complete),
          suppliersScope: JSON.stringify(data.Low_Cost_Suppliers_In_Scope),
          risk: JSON.stringify(data.Risk_Key),
          Capex: data.Capex,
          comment: data.Comment
        }
        setFormData(projectData)
        setInitialformData(projectData)
      }
    } catch (error) {

      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  const fetchCivilScope = async () => {
    try {
      const data = await getCivilScope();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setCivilsScopes(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchMakingScope = async () => {
    try {
      const data = await getMakingScope();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setMakingScopes(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchPacking = async () => {
    try {
      const data = await getPacking();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setPackings(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchEolScope = async () => {
    try {
      const data = await getEolScope();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setEolScopes(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchPrimaryPack = async () => {
    try {
      const data = await getPrimaryPack();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setNewPrimaryPacks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchClosureMould = async () => {
    try {
      const data = await getClosureMould();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setNewClosers(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchESManufacturingComeple = async () => {
    try {
      const data = await getESManufacturingComeple();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setManufacturingDesigns(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchESLowCostSuppliersinScope = async () => {
    try {
      const data = await getESLowCostSuppliersinScope();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setSuppliersSope(output)

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchTechnicalRisk = async () => {
    try {
      const data = await getTechnicalRisk();
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name
      }));
      setRisks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }
  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey)
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved)
    }
  }


  const getCompleteAuditTrail = (initialData: Record<string, any>, updatedData: Record<string, any>): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === 'project_id') continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue)
      });
    }

    return audit;
  }

  const onSubmit = async (data: any, type: any, url: string) => {
    console.log("type ", type)
    if (type === true) {
      let resField = await fetchRequiredField()
      if ((resField?.data && resField?.data.length)) {
        const groupedErrors = groupByModule(resField?.data);
        setValidationErrors(groupedErrors)
        setIsValidationError(true)
        return
      }
    }

    setLoading(true)
    let payload = {
      "Project_Key": projectKey,
      "Civils_Scope_Key": data.civilsScope,
      "Making_Scope_Key": data.makingScope,
      "Packing_Key": data.packing,
      "Eol_Scope_Key": data.eolScope,
      "New_Primary_Pack_Mould": data.newPrimaryPack,
      "New_Closure_Mould": data.newCloser,
      "Design_For_Manufacturing_Complete": data.manufacturingDesign,
      "Low_Cost_Suppliers_In_Scope": data.suppliersScope,
      "Comment": data.comment,
      "Capex": data.Capex,
      "Risk_Key": data.risk
    }

    let initialPayload = {
      "Project_Key": projectKey,
      "Civils_Scope_Key": data.civilsScope,
      "Making_Scope_Key": data.makingScope,
      "Packing_Key": data.packing,
      "Eol_Scope_Key": data.eolScope,
      "New_Primary_Pack_Mould": data.newPrimaryPack,
      "New_Closure_Mould": data.newCloser,
      "Design_For_Manufacturing_Complete": data.manufacturingDesign,
      "Low_Cost_Suppliers_In_Scope": data.suppliersScope,
      "Comment": data.comment,
      "Capex": data.Capex,
      "Risk_Key": data.risk
    }

    const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
    {/* @ts-ignore */ }
    payload.audit = completeAuditTrail;

    if (!isExisting) {
      {/* @ts-ignore */ }
      let res = await createEngineeringScope(payload)
      if (type === true) {
        await pubLishProjectData();
        setProjectDetails({ issaved: type });
        setIsDraftDisabled(type)
      }
      updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
      if (res) {
        setIsExisting(true)
        {/* @ts-ignore */ }
        successToast(res.message)
        setTimeout(() => {
          if (type === true) { navigate(url ? url : `${projectVersion}/project/engineering-scope/${projectId}/${projectKey}`); }
          else { navigate(url ? url : `${projectVersion}/project/procurement/${projectId}/${projectKey}`); }
        }, 3000);
      }
    } else {
      {/* @ts-ignore */ }
      let res = await updateEngineeringScope(payload, projectKey)
      if (projectKey) {
        fetchEngineeringScope(projectKey);
      }
      if (type === true) {
        await pubLishProjectData();
        setProjectDetails({ issaved: type });
        setIsDraftDisabled(type)

      }
      updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
      if (res) {
        {/* @ts-ignore */ }
        successToast(res.message)
        setTimeout(() => {
          if (type === true) { navigate(url ? url : `${projectVersion}/project/engineering-scope/${projectId}/${projectKey}`); }
          else { navigate(url ? url : `${projectVersion}/project/procurement/${projectId}/${projectKey}`); }
        }, 3000);
      }
    }
    setLoading(false)

  }

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };

  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let handleFormChange = (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
  }
  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    handleFormSubmit(false, appData.url)()
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };

  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }

  }


  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField()
      if (resField?.data && resField?.data.length) {
        await handleFormSubmit(false, '')();
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, '')();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 6, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };
  return (
    <>
      <ToastContainer />
      <div className="create-project-content">
        <Card className="" sx={{ padding: "30px", borderRadius: "20px", pt: 3 }}>
          {/* Buttons - Save, Draft, Cancel */}
          <Box>
            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "start", pb: 4 }}
              >
                {
                  isUpload ?
                    <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                    :
                    null
                }

              </Stack>
              {
                !isUpload ?
                  <Stack

                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "end", pb: 4 }}
                  >
                    {
                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                          <Tooltip title="Upload Documents" arrow>
                            <Button
                              onClick={() => handleClickUpload()}
                              sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                            >
                              <img src={uploadIcon} className="icon-wt-uplad" />
                            </Button>
                          </Tooltip>
                          :
                          <>
                          </>
                        :
                        null
                    }
                    <Button disabled={isDisabled} onClick={handleFormSubmit(true, '')} variant="contained"
                      sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important', backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}` }} className={classes.themeButton}>Submit</Button>
                    <Button
                      disabled={isDisabled || projectDetails.issaved}
                      onClick={handleFormSubmit(false, '')}
                      variant="contained"
                      sx={{
                        borderRadius: '30px',
                        px: 4,
                        py: 1,
                        textTransform: 'capitalize',
                        color: 'white !important',
                        backgroundColor: '#2a3fbf !important',
                        '&.Mui-disabled': {
                          backgroundColor: '#d9d9d9 !important',
                          color: '#5f6368 !important'
                        }
                      }}
                      className={classes.themeButton}
                    >
                      Draft & Continue
                    </Button>
                    <Button disabled={isDisabled} onClick={handleCancel} variant="contained" sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize' }} className={classes.cancelButton}>Cancel</Button>

                  </Stack>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>
              }


            </div>
          </Box>
          {
            isUpload ?
              <>
                {/* @ts-ignore */}
                <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={6}></UploadList>
              </>
              :
              <form noValidate>
                <Grid container spacing={3}>
                  <Grid size={12}>
                    {/* <h5 className="txt-mandatory-title">*Fields are mandatory</h5> */}
                  </Grid>
                  <Grid size={4}>
                    <label className="txt-label-input">Civils Scope</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="civilsScope"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("civilsScope", val);
                              clearErrors("civilsScope");
                            }}
                            options={civilsScopes}
                            isError={!!errors.civilsScope}
                          />
                        )}
                      />
                    </div>
                    {errors.civilsScope && <p className="error-message">{errors.civilsScope.message}</p>}
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Making Scope</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="makingScope"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("makingScope", val);
                              clearErrors("makingScope");
                            }}
                            options={makingScopes}
                            isError={!!errors.makingScope}
                          />
                        )}
                      />
                    </div>
                    {errors.makingScope && <p className="error-message">{errors.makingScope.message}</p>}
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Packing<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="packing"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("packing", val);
                              clearErrors("packing");
                            }}
                            options={packings}
                            isError={!!errors.packing}
                          />
                        )}
                      />
                    </div>
                  </Grid>



                  <Grid size={4}>
                    <label className="txt-label-input">EOL Scope<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="eolScope"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("eolScope", val);
                              clearErrors("eolScope");
                            }}
                            options={eolScopes}
                            isError={!!errors.eolScope}
                          />
                        )}
                      />
                    </div>
                  </Grid>


                  <Grid size={4}>
                    <label className="txt-label-input">New Primary Pack Mould<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="newPrimaryPack"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("newPrimaryPack", val);
                              clearErrors("newPrimaryPack");
                            }}
                            options={newPrimaryPacks}
                            isError={!!errors.newPrimaryPack}
                          />
                        )}
                      />
                    </div>
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">New Closure Mould<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="newCloser"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("newCloser", val);
                              clearErrors("newCloser");
                            }}
                            options={newClosers}
                            isError={!!errors.newCloser}
                          />
                        )}
                      />
                    </div>
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Design for Manufacturing Complete<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="manufacturingDesign"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("manufacturingDesign", val);
                              clearErrors("manufacturingDesign");
                            }}
                            options={manufacturingDesigns}
                            isError={!!errors.manufacturingDesign}
                          />
                        )}
                      />
                    </div>
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Low-Cost Suppliers in Scope<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="suppliersScope"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("suppliersScope", val);
                              clearErrors("suppliersScope");
                            }}
                            options={suppliersScope}
                            isError={!!errors.suppliersScope}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid size={4}>
                    <label className="txt-label-input">
                      Capex
                    </label>
                    <TextInput
                      isDisabled={isDisabled}
                      name="Capex"
                      label=""
                      control={control}
                      errors={errors}
                      onChange={(e) => handleFormChange("Capex", e.target.value)}
                      onlyFourDecimal={true}
                      showEuro={true}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} mt={2}>

                  <Grid size={8}>
                    <label className="txt-label-input">Comment</label>
                    <TextInput isDisabled={isDisabled} className="comment-input" isComment={true} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="comment" label="" control={control} errors={errors} multiline />
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Manufacturing Technical Risk<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="risk"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("risk", val);
                              clearErrors("risk");
                            }}
                            options={risks}
                            isError={!!errors.risk}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                </Grid>

              </form>
          }
        </Card>
      </div>

      {/* @ts-ignore */}
      <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} />
      <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />
      <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>
    </>

  );
};

export default EngineeringScope;